export default "__VITE_ASSET__DBOrCI0I__"